<template>
  <div>Déconnection en cours</div>
</template>

<script>
export default {
  methods: {
  },
  mounted () {
    this.$store.commit('reset')
    this.$router.push({name:'accueil'}).catch(() => {})
  }
}
</script>

<style>

</style>
